<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-input-autocomplete
                    :repository="repositories.parametrizacao.especialidade"
                    :search-fields="fields.especialidade"
                    :validations="validations.especialidade"
                    label="Especialidade"
                    :text-field="e => `${e.codigo} - ${e.nome}`"
                    uppercase
                    v-model="model.especialidade"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { repository, object } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                especialidade: { required: true },
            }
        },
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('regulacao.parametrizacao')
        }
    },
    data: () => ({
        fields: {
            especialidade: [
                { key: 'ocupacao.codigo', searchable: true },
                { key: 'especialidade.nome', searchable: true },
            ],
        },
        model: {
            especialidade: null,
        },
    }),
    methods: {
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    if (this.data.model.dataDesejadaEspecialidades.some(e => e.id === this.model.especialidade.id)) {

                        this.showAlert('Especialidade já existente.', 'Atenção')

                        return;
                    }

                    this.data.model.dataDesejadaEspecialidades.push(this.prepareData())

                    this.$emit('save')
                })
        },
        prepareData() {

            return {
                id: this.model.especialidade.id,
                codigo: this.model.especialidade.codigo,
                nome: this.model.especialidade.nome,
            }
        }
    },
    mixins: [repository, object],
    props: {
        data: { type: Object, required: true },
    },
}
</script>